import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

function DefaultFallback({ resetError }: { error: unknown; resetError: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-destructive">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        The error has been reported. Try refreshing the page.
      </p>
      <button
        className="rounded-xl bg-primary px-6 py-2 text-sm text-white"
        onClick={resetError}
      >
        Try again
      </button>
    </div>
  );
}

export function SentryErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={DefaultFallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
